import { render, staticRenderFns } from "./CertificateRule_list.vue?vue&type=template&id=72fbfe6a&scoped=true"
import script from "./CertificateRule_list.vue?vue&type=script&lang=js"
export * from "./CertificateRule_list.vue?vue&type=script&lang=js"
import style0 from "./CertificateRule_list.vue?vue&type=style&index=0&id=72fbfe6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fbfe6a",
  null
  
)

export default component.exports